// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"e14c8718","720":"2b5f213e"}[chunkId] + ".chunk.js";
};